import { Alert, Stack, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

/**
 * Shared rendering helper for the error block displayed in rule-fired,
 * cross-step-transferred and generation-script-ran journal payloads.
 *
 * The three payload renderers all surface the same structured error
 * shape (`code` / `message` / `hint` / `stackHint`) — this component
 * centralises the formatting decisions so they stay consistent.
 */
interface Props {
  error: {
    code: string;
    message: string;
    hint: string | null;
    stackHint: string | null;
  };
}

export function JournalErrorAlert({ error }: Props) {
  return (
    <Alert
      color="red"
      variant="light"
      p="xs"
      icon={<IconAlertTriangle size={16} />}
    >
      <Stack gap={4}>
        <Text size="xs" fw={600}>
          {error.code}: {error.message}
        </Text>
        {error.hint && <Text size="xs">{error.hint}</Text>}
        {error.stackHint && (
          <Text size="xs" c="dimmed" style={{ fontFamily: "monospace" }}>
            {error.stackHint}
          </Text>
        )}
      </Stack>
    </Alert>
  );
}
